import React from 'react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const values = [{
  title: 'Self-starters',
  description: "You don't need to be told what to do next."
}, {
  title: 'Clear communicators',
  description: 'Remote work means writing matters.'
}, {
  title: 'Curious builders',
  description: 'You like figuring things out and making things work.'
}];
// Set to true and add roles when hiring
const isHiring = false;
const openRoles: {
  title: string;
  type: string;
  description: string;
}[] = [
  // Example:
  // { title: 'Senior Shopify Developer', type: 'Full-time', description: 'Build custom Shopify themes and apps for our wine industry clients.' },
];
export function Careers() {
  return <main className="flex-grow bg-[#F2F4F0]" data-id="element-168">
      {/* 1. HERO SECTION */}
      <section className="py-20 md:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-169">
        <h1 className="text-5xl md:text-6xl font-serif font-semibold text-text mb-6" data-id="element-170">
          Careers
        </h1>
        <p className="text-xl md:text-2xl text-muted font-sans max-w-3xl mx-auto" data-id="element-171">
          Join a small team doing interesting work.
        </p>
      </section>

      {/* 2. WHO WE ARE SECTION */}
      <section className="py-16 md:py-24 bg-white" data-id="element-172">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
          <div className="max-w-3xl" data-id="element-174">
            <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-8" data-id="element-175">
              Working at CRU
            </h2>
            <div className="space-y-6 text-lg text-muted leading-relaxed" data-id="element-176">
              <p data-id="element-177">
                We're a small, Melbourne-based team building eCommerce websites
                and Shopify apps. We work with interesting clients—mostly in
                wine, food, and DTC—and we move fast without the chaos.
              </p>
              <p data-id="element-178">Remote-friendly. Flexible hours. No pointless meetings.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. OPEN ROLES SECTION */}
      <section className="py-16 md:py-24 bg-[#F2F4F0]" data-id="element-179">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-12" data-id="element-181">
            Open Roles
          </h2>

          {isHiring && openRoles.length > 0 ? <div className="space-y-6" data-id="element-182">
              {openRoles.map((role, index) => <div key={index} className="bg-white p-8 rounded shadow-warm border border-border hover:border-primary transition-colors" data-id="element-183">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-184">
                    <div data-id="element-185">
                      <h3 className="text-xl font-serif font-semibold text-text mb-2" data-id="element-186">
                        {role.title}
                      </h3>
                      <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-primary/10 text-primary mb-3" data-id="element-187">
                        {role.type}
                      </span>
                      <p className="text-muted" data-id="element-188">{role.description}</p>
                    </div>
                    <a href="mailto:careers@cru.io" className="inline-flex items-center font-semibold text-primary hover:opacity-80 transition-colors whitespace-nowrap" data-id="element-189">
                      Apply
                      <ArrowRight className="ml-2 w-4 h-4" data-id="element-190" />
                    </a>
                  </div>
                </div>)}
            </div> : <div className="bg-white p-8 md:p-12 rounded shadow-warm border border-border text-center max-w-2xl" data-id="element-191">
              <p className="text-lg text-muted mb-8" data-id="element-192">
                No open roles right now. But if you think you'd be a good fit,
                we'd still like to hear from you.
              </p>
              <Link to="/contact" data-id="element-193">
                <Button data-id="element-194">Get in Touch</Button>
              </Link>
            </div>}
        </div>
      </section>

      {/* 4. WHAT WE VALUE SECTION */}
      <section className="py-16 md:py-24 bg-white" data-id="element-195">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-12" data-id="element-197">
            What We Look For
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-198">
            {values.map((value, index) => <div key={index} className="bg-white p-8 rounded shadow-warm border border-border" data-id="element-199">
                <div className="flex items-start mb-4" data-id="element-200">
                  <span className="w-2 h-2 rounded-full bg-primary mt-2 mr-3 flex-shrink-0" data-id="element-201" />
                  <h3 className="text-xl font-serif font-semibold text-text" data-id="element-202">
                    {value.title}
                  </h3>
                </div>
                <p className="text-muted leading-relaxed pl-5" data-id="element-203">
                  {value.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. CTA SECTION */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 text-center bg-[#F2F4F0]" data-id="element-204">
        <div className="max-w-3xl mx-auto space-y-8" data-id="element-205">
          <h2 className="text-4xl md:text-5xl font-serif font-semibold text-text" data-id="element-206">
            Think you'd be a good fit?
          </h2>

          <p className="text-xl text-muted font-sans" data-id="element-207">
            Send us a note—even if we're not actively hiring.
          </p>

          <div className="pt-4" data-id="element-208">
            <Link to="/contact" data-id="element-209">
              <Button size="lg" data-id="element-210">Get in Touch</Button>
            </Link>
          </div>
        </div>
      </section>
    </main>;
}